import i18next from 'i18next'
import { snakeCase } from 'lodash'

export const PRODUCTS__SET = products => dispatch => {
    dispatch({
        type: 'PRODUCTS__SET',
        payload: { products },
    })

    if (products) {
        const list_of_descriptions = {}

        for (const { featureProducts, name: tariff } of products.month) {
            for (const { name: description, featureType, enabled } of featureProducts) {
                if (!enabled || featureType in list_of_descriptions) continue

                list_of_descriptions[featureType] = {
                    tariff,
                    description: i18next.t(`_features.${snakeCase(description)}`),
                }
            }
        }

        dispatch({
            type: 'PROJECT_FEATURES__SET_LIST_OF_DESCRIPTIONS',
            payload: list_of_descriptions,
        })
    }
}
